import { render, staticRenderFns } from "./MobileMainSection.vue?vue&type=template&id=b3adae06&scoped=true"
import script from "./MobileMainSection.vue?vue&type=script&lang=ts"
export * from "./MobileMainSection.vue?vue&type=script&lang=ts"
import style0 from "./MobileMainSection.vue?vue&type=style&index=0&id=b3adae06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3adae06",
  null
  
)

export default component.exports